module.exports = __webpack_public_path__ + "static/media/_T4-Kubernetes.a2a9da6e.svg";